// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"96308e70ed773ccb2351","293":"e3587ddc2d9528e2b7a4","518":"1e438dd95572fb71b797","779":"9ae332ab3549e78b28a4"}[chunkId] + ".js";
};